"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _getRoundedValueAndLabelUnits = _interopRequireDefault(require("../get-rounded-value-and-label-units"));

var _getNumberWithMaxDecimalPlaces = _interopRequireDefault(require("../get-number-with-max-decimal-places"));

var MAX_DECIMAL_PLACES = 2;
/**
 * Format a number to be a maximum of three digits and a magnitude letter (e.g. 1.28B)
 * @alias module:htmlShortNumberFormatter
 *
 * @param {number} value - The number to be formatted to a maximum of three digits
 * @returns {string} - Value formatted to a maximum of three digits and a magnitude letter
 */

function htmlShortNumberFormatter(value) {
  var _getRoundedValueAndDa = (0, _getRoundedValueAndLabelUnits.default)(value),
      roundedValue = _getRoundedValueAndDa.roundedValue,
      dataLabelUnits = _getRoundedValueAndDa.dataLabelUnits;

  if (dataLabelUnits === '') {
    return "<span class=\"mw-label-formatted-number__value\">".concat((0, _getNumberWithMaxDecimalPlaces.default)(roundedValue, 0), "</span>");
  }

  return "<span class=\"mw-label-formatted-number__value\">".concat((0, _getNumberWithMaxDecimalPlaces.default)(roundedValue, MAX_DECIMAL_PLACES), "</span><span class=\"mw-label-formatted-number__units\">").concat(dataLabelUnits, "</span>");
}
/**
 * @module htmlShortNumberFormatter
 */


var _default = htmlShortNumberFormatter;
exports.default = _default;